import { SearchDocumentType } from '@wix/client-search-sdk';
import { getSupportedApps } from '../integrations/apps';

export const getTabLabelTranslations = (): Record<SearchDocumentType, string> =>
  getSupportedApps().reduce((labels, app) => {
    labels[app.documentType] = app.translations.tabLabel;
    return labels;
  }, {} as Record<SearchDocumentType, string>);

export const getTabLabelWithCountTranslations = (): Record<
  SearchDocumentType,
  string
> =>
  getSupportedApps().reduce((labels, app) => {
    labels[app.documentType] = app.translations.tabLabelWithCount;
    return labels;
  }, {} as Record<SearchDocumentType, string>);

export const getTabAccessibilityLabelTranslations = (): Record<
  SearchDocumentType,
  string
> =>
  getSupportedApps().reduce((labels, app) => {
    labels[app.documentType] = app.translations.tabAccessibilityLabel;
    return labels;
  }, {} as Record<SearchDocumentType, string>);
